module.exports = "/static/media/group.559dd6a6.svg";